__turbopack_context__.v({
  "agencySection": "PricingPackages-module-scss-module__FX8R6G__agencySection",
  "pricingTable": "PricingPackages-module-scss-module__FX8R6G__pricingTable",
  "section": "PricingPackages-module-scss-module__FX8R6G__section",
  "tout": "PricingPackages-module-scss-module__FX8R6G__tout",
  "wrapper": "PricingPackages-module-scss-module__FX8R6G__wrapper",
});
